import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hangang_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORY_META = {
  "alcohol-beverages": { name: "Alcohol Beverages", emoji: "🍶", color: "from-pink-300 to-rose-400", short: "Soju, makgeolli & nightlife pours" },
  "wellness-beverages": { name: "Wellness Beverages", emoji: "🧃", color: "from-emerald-300 to-cyan-400", short: "Tonics, collagen drinks & detox" },
  "wellness-supplements": { name: "Wellness Supplements", emoji: "💊", color: "from-violet-300 to-fuchsia-400", short: "Red ginseng, biotics & beauty-in" },
  "cosmetics": { name: "Cosmetics", emoji: "💄", color: "from-rose-300 to-pink-400", short: "Cushions, lips, glow-base" },
  "skin-care": { name: "Skin Care", emoji: "✨", color: "from-cyan-300 to-blue-400", short: "Serums, essences, masks" },
  "hair-care": { name: "Hair Care", emoji: "💇", color: "from-amber-300 to-pink-300", short: "Treatments, tonics, scalp care" },
  "beauty-devices": { name: "Beauty Devices", emoji: "🔮", color: "from-indigo-300 to-purple-400", short: "LED, sonic & at-home tech" },
};

// Top-level groupings shown publicly.
// Each group includes one or more raw category slugs from CATEGORY_META.
export const CATEGORY_GROUPS = [
  {
    slug: "beverages",
    name: "Beverages",
    tagline: "Lifestyle pours",
    color: "from-[#FF6B9E] to-[#F43F5E]",
    subs: [
      { slug: "alcohol-beverages", name: "Soju" },
      { slug: "alcohol-beverages", name: "Makgeolli" },
      { slug: "alcohol-beverages", name: "Cocktails" },
    ],
    categories: ["alcohol-beverages"],
  },
  {
    slug: "beauty",
    name: "Beauty",
    tagline: "Glass skin, polished glow",
    color: "from-[#A78BFA] to-[#38BDF8]",
    subs: [
      { slug: "skin-care", name: "Skin Care" },
      { slug: "hair-care", name: "Hair Care" },
      { slug: "cosmetics", name: "Cosmetics" },
    ],
    categories: ["skin-care", "hair-care", "cosmetics"],
  },
  {
    slug: "wellness",
    name: "Wellness",
    tagline: "Inner-out radiance",
    color: "from-[#34D399] to-[#38BDF8]",
    subs: [
      { slug: "wellness-supplements", name: "Supplements" },
      { slug: "wellness-beverages", name: "Beverages" },
    ],
    categories: ["wellness-supplements", "wellness-beverages"],
  },
  {
    slug: "beauty-devices",
    name: "Beauty Devices",
    tagline: "At-home beauty tech",
    color: "from-[#0F172A] to-[#A78BFA]",
    subs: [
      { slug: "beauty-devices", name: "LED" },
      { slug: "beauty-devices", name: "Sonic" },
      { slug: "beauty-devices", name: "Microcurrent" },
    ],
    categories: ["beauty-devices"],
    comingSoon: true,
  },
];

export function findGroup(slug) {
  return CATEGORY_GROUPS.find((g) => g.slug === slug);
}

export function imageSrc(p) {
  if (!p) return "";
  if (p.startsWith("http") || p.startsWith("data:")) return p;
  // assume server path returned by upload: "/api/files/..."
  return `${BACKEND_URL}${p}`;
}
